import React from "react";
import SolarCalculator from "@/components/SolarCalculator";

/** Dashboard-embedded calculator: kills the section's outer padding/gradient so it
 * sits cleanly inside the dashboard surface (and dark mode). */
export default function CalculatorPage() {
  return (
    <div data-testid="calculator-page" className="-mx-2 sm:-mx-0 calc-dashboard-mode">
      <div className="mb-6">
        <p className="overline">Sustainability tools</p>
        <h1 className="text-3xl font-heading font-medium text-[#0A2540] dark:text-white mt-2">Solar savings calculator</h1>
        <p className="text-sm text-[#475569] dark:text-slate-400 mt-1 max-w-2xl">
          Get a personalized estimate of your annual & 25-year savings, plus a recommended system size — all in 60 seconds.
        </p>
      </div>
      <SolarCalculator embedded />
      <style>{`
        /* When embedded in dashboard, neutralize the section's outer padding & gradient
           so it doesn't fight the dashboard background. */
        .calc-dashboard-mode section#calculator {
          padding: 0 !important;
          background: transparent !important;
        }
        .calc-dashboard-mode section#calculator > div:first-child,
        .calc-dashboard-mode section#calculator > .absolute {
          display: none !important;
        }
        .calc-dashboard-mode section#calculator .max-w-6xl {
          padding: 0 !important;
          margin: 0 !important;
          max-width: 100% !important;
        }
      `}</style>
    </div>
  );
}
